import { render, staticRenderFns } from "./EntriesCard.vue?vue&type=template&id=74a2374b&"
import script from "./EntriesCard.vue?vue&type=script&lang=ts&"
export * from "./EntriesCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports